<div class="min-h-screen text-sm dark:bg-slate-900 p-4 md:p-8 text-slate-600 dark:text-slate-300">

  <!-- ======================= LIST ======================= -->
  <ng-container *ngIf="editorMode() === 'list'">
    <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-6 gap-4">
      <div>
        <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">กลุ่มสิทธิ์จอดฟรี</h1>
        <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
          <ng-container *ngIf="selectedSiteName; else noSiteHint">
            ลาน <span class="font-bold text-amber-600">{{ selectedSiteName }}</span>
            · จัดกลุ่มผู้ใช้ตามหมวดหมู่ ฝ่ายอาคาร / บริษัทผู้เช่า
          </ng-container>
          <ng-template #noSiteHint>เลือกลานจากแถบด้านข้างก่อน</ng-template>
        </p>
      </div>
      <div *ngIf="selectedSiteId" class="flex flex-col sm:flex-row items-center gap-3 w-full sm:w-auto">
        <button type="button" (click)="onRefresh()" title="รีเฟรช"
          class="w-full sm:w-auto p-3 bg-white/95 dark:bg-slate-900/95 text-slate-500 rounded-2xl shadow-sm border border-slate-100/50 hover:text-amber-500 transition-all flex items-center justify-center">
          <span class="material-icons" [class.animate-spin]="isLoading()">refresh</span>
        </button>
        <button *ngIf="canUpdate" type="button" (click)="startCreate()"
          class="w-full sm:w-auto px-5 py-3 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-2xl shadow-lg shadow-amber-200/50 transition-all flex items-center justify-center gap-2 cursor-pointer">
          <span class="material-icons text-[18px]">group_add</span>
          สร้างกลุ่มใหม่
        </button>
      </div>
    </div>

    <div *ngIf="!selectedSiteId"
      class="animate-fade-in bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-2xl border border-slate-100/50 py-20 text-center text-slate-400">
      <span class="material-icons text-5xl mb-2">place</span>
      <p class="font-bold">กรุณาเลือกลานจากแถบด้านข้าง</p>
      <p class="text-xs mt-1">กลุ่มสิทธิ์ผูกกับลานทีละลาน</p>
    </div>

    <ng-container *ngIf="selectedSiteId">
      <!-- Stats -->
      <div class="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <div class="animate-fade-in bg-white/95 dark:bg-slate-900/95 rounded-2xl p-5 shadow-xl border border-slate-100/50">
          <div class="w-10 h-10 rounded-xl flex items-center justify-center mb-3 bg-amber-50 text-amber-500">
            <span class="material-icons">groups</span>
          </div>
          <h4 class="text-slate-400 text-xs font-bold uppercase tracking-wider mb-1">กลุ่มทั้งหมด</h4>
          <div class="text-2xl font-black text-slate-800 dark:text-slate-100">{{ listStats().total | number }}</div>
          <p class="text-[11px] text-slate-400">เปิดใช้ {{ listStats().active | number }} กลุ่ม</p>
        </div>
        <div class="animate-fade-in bg-white/95 dark:bg-slate-900/95 rounded-2xl p-5 shadow-xl border border-slate-100/50">
          <div class="w-10 h-10 rounded-xl flex items-center justify-center mb-3 bg-sky-50 text-sky-500">
            <span class="material-icons">apartment</span>
          </div>
          <h4 class="text-slate-400 text-xs font-bold uppercase tracking-wider mb-1">ฝ่ายอาคาร</h4>
          <div class="text-2xl font-black text-slate-800 dark:text-slate-100">{{ listStats().building | number }}</div>
        </div>
        <div class="animate-fade-in bg-white/95 dark:bg-slate-900/95 rounded-2xl p-5 shadow-xl border border-slate-100/50">
          <div class="w-10 h-10 rounded-xl flex items-center justify-center mb-3 bg-violet-50 text-violet-500">
            <span class="material-icons">business_center</span>
          </div>
          <h4 class="text-slate-400 text-xs font-bold uppercase tracking-wider mb-1">บริษัทผู้เช่า</h4>
          <div class="text-2xl font-black text-slate-800 dark:text-slate-100">{{ listStats().tenant | number }}</div>
        </div>
        <div class="animate-fade-in bg-white/95 dark:bg-slate-900/95 rounded-2xl p-5 shadow-xl border border-slate-100/50">
          <div class="w-10 h-10 rounded-xl flex items-center justify-center mb-3 bg-emerald-50 text-emerald-500">
            <span class="material-icons">person</span>
          </div>
          <h4 class="text-slate-400 text-xs font-bold uppercase tracking-wider mb-1">สมาชิกรวม</h4>
          <div class="text-2xl font-black text-slate-800 dark:text-slate-100">{{ listStats().members | number }}</div>
        </div>
      </div>

      <!-- Toolbar: category tabs + search -->
      <div class="flex flex-col lg:flex-row lg:items-center justify-between gap-3 mb-6">
        <div class="inline-flex flex-wrap gap-2 p-1.5 rounded-2xl bg-white/95 dark:bg-slate-900/95 border border-slate-100/50 shadow-sm">
          <button type="button" (click)="listCategory.set('all')"
            class="px-4 py-2 rounded-xl font-bold transition-all flex items-center gap-2"
            [ngClass]="listCategory() === 'all' ? 'bg-amber-400 text-white shadow' : 'text-slate-500 hover:bg-amber-50'">
            ทั้งหมด
            <span class="text-[11px] px-1.5 rounded-md" [ngClass]="listCategory() === 'all' ? 'bg-white/30' : 'bg-slate-100'">{{ categoryCount('all') }}</span>
          </button>
          <button type="button" *ngFor="let c of categories" (click)="listCategory.set(c.value)"
            class="px-4 py-2 rounded-xl font-bold transition-all flex items-center gap-2"
            [ngClass]="listCategory() === c.value ? 'bg-amber-400 text-white shadow' : 'text-slate-500 hover:bg-amber-50'">
            <span class="material-icons text-[18px]">{{ c.icon }}</span>
            {{ c.label }}
            <span class="text-[11px] px-1.5 rounded-md" [ngClass]="listCategory() === c.value ? 'bg-white/30' : 'bg-slate-100'">{{ categoryCount(c.value) }}</span>
          </button>
        </div>
        <div class="flex flex-col sm:flex-row gap-3 w-full lg:max-w-lg">
          <select [ngModel]="listStatus()" (ngModelChange)="listStatus.set($event)"
            class="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm rounded-xl font-bold px-3 py-2.5 outline-none focus:ring-2 focus:ring-amber-200">
            <option value="all">ทุกสถานะ</option>
            <option value="active">เปิดใช้</option>
            <option value="inactive">ปิด</option>
          </select>
          <div class="relative flex-1">
            <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[20px]">search</span>
            <input type="text" [ngModel]="listSearch()" (ngModelChange)="listSearch.set($event)"
              placeholder="ค้นหาชื่อกลุ่ม / ID..."
              class="w-full pl-10 pr-4 py-2.5 bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 text-sm font-medium focus:ring-2 focus:ring-amber-200 focus:outline-none" />
          </div>
        </div>
      </div>

      <!-- Category sections -->
      <div class="space-y-6" [class.opacity-50]="isLoading()">
        <div *ngFor="let section of categorySections()"
          class="animate-fade-in bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 overflow-hidden">
          <div class="p-6 border-b border-slate-100/50 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
            <div class="flex items-center gap-3">
              <div class="w-11 h-11 rounded-xl flex items-center justify-center"
                [ngClass]="section.meta.value === 'tenant' ? 'bg-violet-50 text-violet-500' : 'bg-sky-50 text-sky-500'">
                <span class="material-icons">{{ section.meta.icon }}</span>
              </div>
              <div>
                <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100">
                  {{ section.meta.label }}
                  <span class="text-sm text-slate-400 font-semibold">({{ section.rows.length }})</span>
                </h3>
                <p class="text-xs text-slate-400">{{ section.meta.description }}</p>
              </div>
            </div>
            <button *ngIf="canUpdate" type="button" (click)="startCreate(section.meta.value)"
              class="px-4 py-2 rounded-xl border border-amber-200 text-amber-600 font-bold hover:bg-amber-50 transition-all flex items-center gap-1.5 self-start sm:self-auto">
              <span class="material-icons text-[18px]">add</span>
              สร้างกลุ่ม{{ section.meta.label }}
            </button>
          </div>

          <div class="overflow-x-auto custom-scrollbar">
            <table class="w-full text-left border-collapse">
              <thead class="bg-white/95 dark:bg-slate-900/95 border-b border-slate-100/50">
                <tr class="text-xs font-bold text-slate-400 uppercase tracking-widest">
                  <th class="p-4">ชื่อกลุ่ม</th>
                  <th class="p-4 text-center">สมาชิก</th>
                  <th class="p-4 text-center">บริษัทผู้เช่า</th>
                  <th class="p-4 text-center">Subscription</th>
                  <th class="p-4">สิทธิ์</th>
                  <th class="p-4">สถานะ</th>
                  <th class="p-4 text-center w-[120px]">จัดการ</th>
                </tr>
              </thead>
              <tbody class="divide-y divide-slate-50 dark:divide-slate-800">
                <tr *ngFor="let row of section.rows; trackBy: trackRow" (click)="openGroup(row)"
                  class="hover:bg-amber-50/40 dark:hover:bg-slate-800/50 transition-all cursor-pointer">
                  <td class="p-4">
                    <span class="text-sm font-bold text-slate-700 dark:text-slate-200">{{ row.name || ('กลุ่ม #' + row.id) }}</span>
                    <p class="text-xs text-slate-400 mt-0.5 font-mono">#{{ row.id }}</p>
                  </td>
                  <td class="p-4 text-center font-black text-slate-700 dark:text-slate-200">{{ row.userCount | number }}</td>
                  <td class="p-4 text-center">
                    <span *ngIf="row.clientCount; else allClients" class="font-black text-slate-700 dark:text-slate-200">{{ row.clientCount | number }}</span>
                    <ng-template #allClients>
                      <span class="inline-flex px-2 py-0.5 rounded-lg text-[11px] font-semibold bg-slate-100 text-slate-500 dark:bg-slate-800">ทุกบริษัท</span>
                    </ng-template>
                  </td>
                  <td class="p-4 text-center font-black text-slate-700 dark:text-slate-200">{{ row.subscriptionCount | number }}</td>
                  <td class="p-4">
                    <div class="flex flex-wrap gap-1">
                      <span *ngIf="row.canManageQuota" class="text-[11px] px-2 py-0.5 rounded-lg font-semibold bg-sky-50 text-sky-700">โควต้า</span>
                      <span *ngIf="row.canManageFreeCards" class="text-[11px] px-2 py-0.5 rounded-lg font-semibold bg-emerald-50 text-emerald-700">บัตรฟรี</span>
                      <span *ngIf="row.canDeleteCardReturnQuota" class="text-[11px] px-2 py-0.5 rounded-lg font-semibold bg-rose-50 text-rose-700">ลบคืนโควต้า</span>
                      <span *ngIf="!row.canManageQuota && !row.canManageFreeCards && !row.canDeleteCardReturnQuota" class="text-xs text-slate-400">—</span>
                    </div>
                  </td>
                  <td class="p-4">
                    <span class="inline-flex px-2.5 py-1 rounded-full text-xs font-semibold"
                      [ngClass]="row.active
                        ? 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400'
                        : 'bg-slate-100 text-slate-500 dark:bg-slate-700 dark:text-slate-300'">
                      {{ row.active ? 'เปิดใช้' : 'ปิด' }}
                    </span>
                  </td>
                  <td class="p-4 text-center">
                    <div class="inline-flex items-center gap-1.5">
                      <button type="button" (click)="openHistory(row, $event)" title="ดูประวัติ"
                        class="w-8 h-8 rounded-lg flex items-center justify-center border border-slate-100 hover:border-sky-400 text-slate-400 hover:text-sky-500 transition-all cursor-pointer">
                        <span class="material-icons text-base">history</span>
                      </button>
                      <button type="button" (click)="$event.stopPropagation(); openGroup(row)" [title]="canUpdate ? 'จัดการ' : 'ดูรายละเอียด'"
                        class="w-8 h-8 rounded-lg flex items-center justify-center border border-slate-100 hover:border-amber-400 text-slate-400 hover:text-amber-500 transition-all cursor-pointer">
                        <span class="material-icons text-base">{{ canUpdate ? 'edit' : 'visibility' }}</span>
                      </button>
                    </div>
                  </td>
                </tr>
                <tr *ngIf="section.rows.length === 0 && !isLoading()">
                  <td colspan="7" class="py-12 text-center text-slate-400">
                    <span class="material-icons text-4xl mb-1">{{ listSearch() ? 'search_off' : 'group_off' }}</span>
                    <p class="font-bold">{{ listSearch() ? 'ไม่พบกลุ่มตามคำค้น' : 'ยังไม่มีกลุ่ม' + section.meta.label + 'ในลานนี้' }}</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <!-- ======================= EDITOR / WIZARD ======================= -->
  <ng-container *ngIf="isEditing">
    <div class="flex flex-col md:flex-row md:items-end justify-between gap-3 mb-6">
      <div>
        <button type="button" (click)="backToList()"
          class="text-sm font-bold text-slate-500 hover:text-amber-600 inline-flex items-center gap-1 mb-2">
          <span class="material-icons text-[18px]">arrow_back</span>
          กลับรายการกลุ่ม
        </button>
        <h1 class="text-2xl md:text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">
          {{ isCreate ? 'สร้างกลุ่มสิทธิ์จอดฟรี' : ('จัดการกลุ่ม: ' + (form.name || ('#' + form.id))) }}
        </h1>
        <p class="text-slate-500 mt-1">
          ลาน <span class="font-bold text-amber-600">{{ selectedSiteName }}</span>
          · หมวด <span class="font-bold">{{ formCategory.label }}</span>
        </p>
      </div>
      <button *ngIf="!isCreate && form.id" type="button" (click)="openHistoryForCurrentGroup()"
        class="px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 font-bold flex items-center gap-2 self-start md:self-auto hover:text-sky-600">
        <span class="material-icons text-[18px]">history</span>
        ประวัติกลุ่มนี้
      </button>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-[260px_1fr] gap-6">
      <!-- Stepper -->
      <nav class="lg:sticky lg:top-4 self-start bg-white/95 dark:bg-slate-900/95 rounded-2xl border border-slate-100/50 shadow-xl p-3">
        <ol class="flex lg:flex-col gap-1 overflow-x-auto">
          <li *ngFor="let s of wizardSteps" class="shrink-0">
            <button type="button" (click)="goStep(s.id)"
              class="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-left transition-all"
              [ngClass]="wizardStep() === s.id ? 'bg-amber-50 dark:bg-amber-950/30' : 'hover:bg-slate-50 dark:hover:bg-slate-800/50'">
              <span class="w-8 h-8 shrink-0 rounded-full flex items-center justify-center text-xs font-black"
                [ngClass]="wizardStep() === s.id
                  ? 'bg-amber-400 text-white'
                  : stepDone(s.id) ? 'bg-emerald-100 text-emerald-600' : 'bg-slate-100 text-slate-400 dark:bg-slate-800'">
                <span *ngIf="stepDone(s.id) && wizardStep() !== s.id" class="material-icons text-[16px]">check</span>
                <span *ngIf="!(stepDone(s.id) && wizardStep() !== s.id)">{{ s.id }}</span>
              </span>
              <span class="min-w-0">
                <span class="block text-xs font-extrabold"
                  [ngClass]="wizardStep() === s.id ? 'text-amber-700 dark:text-amber-300' : 'text-slate-700 dark:text-slate-200'">{{ s.title }}</span>
                <span class="hidden lg:block text-[11px] text-slate-400 truncate">
                  <ng-container [ngSwitch]="s.id">
                    <ng-container *ngSwitchCase="1">{{ formCategory.label }}</ng-container>
                    <ng-container *ngSwitchCase="2">{{ clientScopeMode === 'all' ? 'ทุกบริษัทในลาน' : (form.clientIds.length + ' บริษัท') }}</ng-container>
                    <ng-container *ngSwitchCase="3">{{ form.resUserIds.length }} คน</ng-container>
                    <ng-container *ngSwitchCase="5">{{ form.subscriptionIds.length }} รายการ</ng-container>
                    <ng-container *ngSwitchDefault>{{ s.hint }}</ng-container>
                  </ng-container>
                </span>
              </span>
            </button>
          </li>
        </ol>
      </nav>

      <!-- Step body -->
      <div class="bg-white/95 dark:bg-slate-900/95 rounded-2xl border border-slate-100/50 shadow-xl p-5 md:p-7 min-w-0">
        <div class="flex items-center gap-3 mb-5">
          <div class="w-10 h-10 rounded-xl bg-amber-50 text-amber-500 flex items-center justify-center">
            <span class="material-icons">{{ currentStepMeta.icon }}</span>
          </div>
          <div>
            <p class="text-[11px] font-bold text-slate-400">ขั้นที่ {{ currentStepMeta.id }} / {{ wizardSteps.length }}</p>
            <h2 class="text-lg font-extrabold text-slate-800 dark:text-slate-100">{{ currentStepMeta.title }}</h2>
            <p class="text-xs text-slate-400">{{ currentStepMeta.hint }}</p>
          </div>
        </div>

        <!-- Step 1: category + name -->
        <div *ngIf="wizardStep() === 1" class="space-y-6 max-w-3xl">
          <div>
            <label class="text-xs font-bold text-slate-500 uppercase">หมวดหมู่กลุ่ม *</label>
            <div class="mt-2 grid grid-cols-1 md:grid-cols-2 gap-3">
              <button type="button" *ngFor="let c of categories" (click)="selectCategory(c.value)" [disabled]="isLocked"
                class="text-left p-4 rounded-2xl border-2 transition-all disabled:cursor-not-allowed"
                [ngClass]="form.groupType === c.value
                  ? 'border-amber-400 bg-amber-50/70 dark:bg-amber-950/20'
                  : 'border-slate-200 dark:border-slate-700 hover:border-amber-200'">
                <div class="flex items-start gap-3">
                  <div class="w-11 h-11 shrink-0 rounded-xl flex items-center justify-center"
                    [ngClass]="c.value === 'tenant' ? 'bg-violet-50 text-violet-500' : 'bg-sky-50 text-sky-500'">
                    <span class="material-icons">{{ c.icon }}</span>
                  </div>
                  <div class="flex-1">
                    <p class="font-extrabold text-slate-800 dark:text-slate-100">{{ c.label }}</p>
                    <p class="text-xs text-slate-500 mt-0.5">{{ c.description }}</p>
                  </div>
                  <span class="material-icons" [ngClass]="form.groupType === c.value ? 'text-amber-500' : 'text-slate-300'">
                    {{ form.groupType === c.value ? 'radio_button_checked' : 'radio_button_unchecked' }}
                  </span>
                </div>
              </button>
            </div>
            <p *ngIf="isCreate" class="text-[11px] text-slate-400 mt-2">
              เลือกหมวดแล้วระบบตั้งสิทธิ์เริ่มต้นให้ (แก้ได้ในขั้นที่ 4)
            </p>
          </div>

          <div>
            <label class="text-xs font-bold text-slate-500 uppercase">ชื่อกลุ่ม *</label>
            <input type="text" [(ngModel)]="form.name" [disabled]="isLocked"
              [placeholder]="form.groupType === 'tenant' ? 'เช่น ตัวแทนบริษัท ABC จำกัด' : 'เช่น ฝ่ายอาคารลาน A'"
              class="mt-1 w-full rounded-xl border border-slate-200 dark:border-slate-700 px-3 py-2.5 bg-white dark:bg-slate-900 font-semibold focus:ring-2 focus:ring-amber-200 outline-none" />
          </div>

          <label class="flex items-center justify-between gap-3 p-4 rounded-xl border border-slate-200 dark:border-slate-700 cursor-pointer">
            <span>
              <span class="font-bold block text-slate-700 dark:text-slate-200">เปิดใช้งานกลุ่มนี้</span>
              <span class="text-xs text-slate-400">ปิดแล้วสมาชิกจะไม่ได้รับสิทธิ์จากกลุ่มนี้</span>
            </span>
            <input type="checkbox" class="w-5 h-5 accent-amber-500" [(ngModel)]="form.active" [disabled]="isLocked" />
          </label>
        </div>

        <!-- Step 2: tenant companies -->
        <div *ngIf="wizardStep() === 2" class="space-y-5">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-3 max-w-3xl">
            <button type="button" (click)="setClientScopeMode('all')" [disabled]="isLocked"
              class="text-left p-4 rounded-2xl border-2 transition-all disabled:cursor-not-allowed"
              [ngClass]="clientScopeMode === 'all' ? 'border-amber-400 bg-amber-50/70 dark:bg-amber-950/20' : 'border-slate-200 dark:border-slate-700 hover:border-amber-200'">
              <p class="font-extrabold text-slate-800 dark:text-slate-100 flex items-center gap-2">
                <span class="material-icons text-[20px] text-sky-500">domain</span>
                ทุกบริษัทผู้เช่าในลาน
              </p>
              <p class="text-xs text-slate-500 mt-1">เหมาะกับฝ่ายอาคารที่ดูแลทั้งลาน</p>
            </button>
            <button type="button" (click)="setClientScopeMode('specific')" [disabled]="isLocked"
              class="text-left p-4 rounded-2xl border-2 transition-all disabled:cursor-not-allowed"
              [ngClass]="clientScopeMode === 'specific' ? 'border-amber-400 bg-amber-50/70 dark:bg-amber-950/20' : 'border-slate-200 dark:border-slate-700 hover:border-amber-200'">
              <p class="font-extrabold text-slate-800 dark:text-slate-100 flex items-center gap-2">
                <span class="material-icons text-[20px] text-violet-500">business_center</span>
                เลือกเฉพาะบริษัท
              </p>
              <p class="text-xs text-slate-500 mt-1">จำกัดให้เห็น / จัดการเฉพาะบริษัทที่เลือก</p>
            </button>
          </div>

          <div *ngIf="clientScopeMode === 'all'"
            class="rounded-xl border border-sky-200 bg-sky-50/70 dark:bg-sky-950/20 p-4 text-sm text-sky-900 dark:text-sky-100 flex items-center gap-2">
            <span class="material-icons text-[18px]">info</span>
            สมาชิกในกลุ่มจะเห็นและจัดการได้ทุกบริษัทผู้เช่าในลาน {{ selectedSiteName }}
          </div>

          <div *ngIf="clientScopeMode === 'specific'" class="grid grid-cols-1 xl:grid-cols-2 gap-4">
            <!-- search side -->
            <div class="rounded-2xl border border-slate-200 dark:border-slate-700 overflow-hidden flex flex-col">
              <div class="p-3 border-b border-slate-100 dark:border-slate-800 space-y-2">
                <p class="text-xs font-bold text-slate-500 uppercase">1 · ค้นหาบริษัทผู้เช่า</p>
                <div class="relative">
                  <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[20px]">search</span>
                  <input type="text" [(ngModel)]="clientSearch" (ngModelChange)="onClientSearchChange()"
                    placeholder="ชื่อบริษัท / เลขภาษี / ผู้ติดต่อ / ID"
                    class="w-full pl-10 pr-4 py-2.5 bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 text-sm focus:ring-2 focus:ring-amber-200 focus:outline-none" />
                </div>
                <div class="flex items-center justify-between text-xs">
                  <span class="text-slate-400">พบ {{ clientTotal() | number }} บริษัท</span>
                  <button type="button" (click)="toggleAllClientsOnPage()" [disabled]="isLocked || !clientOptions().length"
                    class="font-bold text-amber-600 disabled:opacity-40">
                    {{ allClientsOnPageSelected ? 'เอาออกทั้งหน้านี้' : 'เลือกทั้งหน้านี้' }}
                  </button>
                </div>
              </div>
              <div class="relative flex-1 min-h-[320px] max-h-[420px] overflow-y-auto custom-scrollbar divide-y divide-slate-50 dark:divide-slate-800">
                <label *ngFor="let c of clientOptions(); trackBy: trackById"
                  class="flex items-center gap-3 px-4 py-2.5 cursor-pointer hover:bg-amber-50/60 dark:hover:bg-slate-800/50"
                  [class.bg-amber-50]="isClientSelected(c.id)">
                  <input type="checkbox" class="w-4 h-4 accent-amber-500" [checked]="isClientSelected(c.id)" (change)="toggleClient(c)" [disabled]="isLocked" />
                  <span class="min-w-0 flex-1">
                    <span class="block font-semibold text-slate-800 dark:text-slate-100 truncate">{{ c.name }}</span>
                    <span class="block text-[11px] text-slate-400 truncate">
                      #{{ c.id }}<span *ngIf="c.taxId"> · ภาษี {{ c.taxId }}</span><span *ngIf="c.contact"> · {{ c.contact }}</span>
                    </span>
                  </span>
                </label>
                <p *ngIf="!clientOptions().length && !isClientLoading()" class="p-8 text-center text-slate-400">ไม่พบบริษัทผู้เช่า</p>
                <div *ngIf="isClientLoading()" class="absolute inset-0 bg-white/60 dark:bg-slate-900/60 flex items-center justify-center">
                  <span class="material-icons animate-spin text-amber-400 text-3xl">autorenew</span>
                </div>
              </div>
              <div *ngIf="clientTotalPages() > 1" class="p-2 border-t border-slate-100 dark:border-slate-800 flex items-center justify-between text-xs">
                <button type="button" (click)="setClientPage(clientPage() - 1)" [disabled]="clientPage() === 1"
                  class="w-8 h-8 rounded-lg border border-slate-200 flex items-center justify-center disabled:opacity-30 hover:text-amber-500">
                  <span class="material-icons text-sm">chevron_left</span>
                </button>
                <span class="font-bold text-slate-500">หน้า {{ clientPage() }} / {{ clientTotalPages() }}</span>
                <button type="button" (click)="setClientPage(clientPage() + 1)" [disabled]="clientPage() >= clientTotalPages()"
                  class="w-8 h-8 rounded-lg border border-slate-200 flex items-center justify-center disabled:opacity-30 hover:text-amber-500">
                  <span class="material-icons text-sm">chevron_right</span>
                </button>
              </div>
            </div>

            <!-- selected side -->
            <div class="rounded-2xl border border-amber-200 dark:border-amber-900/50 overflow-hidden flex flex-col">
              <div class="p-3 border-b border-amber-100 dark:border-amber-900/40 bg-amber-50/50 dark:bg-amber-950/20 space-y-2">
                <div class="flex items-center justify-between">
                  <p class="text-xs font-bold text-amber-700 uppercase">2 · เลือกแล้ว {{ form.clientIds.length | number }} บริษัท</p>
                  <button type="button" (click)="clearClients()" [disabled]="isLocked || !form.clientIds.length"
                    class="text-xs font-bold text-rose-500 disabled:opacity-40">ล้างทั้งหมด</button>
                </div>
                <div *ngIf="form.clientIds.length > 8" class="relative">
                  <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[18px]">filter_list</span>
                  <input type="text" [(ngModel)]="selectedClientFilter" placeholder="กรองในรายการที่เลือก..."
                    class="w-full pl-9 pr-3 py-2 bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 text-xs focus:outline-none focus:ring-2 focus:ring-amber-200" />
                </div>
              </div>
              <div class="flex-1 min-h-[320px] max-h-[420px] overflow-y-auto custom-scrollbar divide-y divide-slate-50 dark:divide-slate-800">
                <div *ngFor="let c of selectedClients; trackBy: trackById" class="flex items-center gap-3 px-4 py-2.5">
                  <span class="material-icons text-[18px] text-violet-400">business_center</span>
                  <span class="min-w-0 flex-1">
                    <span class="block font-semibold text-slate-800 dark:text-slate-100 truncate">{{ c.name }}</span>
                    <span class="block text-[11px] text-slate-400">#{{ c.id }}<span *ngIf="c.taxId"> · ภาษี {{ c.taxId }}</span></span>
                  </span>
                  <button type="button" (click)="removeClient(c.id)" [disabled]="isLocked" title="เอาออก"
                    class="w-7 h-7 rounded-lg flex items-center justify-center text-slate-400 hover:text-rose-500 hover:bg-rose-50">
                    <span class="material-icons text-[16px]">close</span>
                  </button>
                </div>
                <div *ngIf="!form.clientIds.length" class="p-8 text-center text-slate-400">
                  <span class="material-icons text-3xl">touch_app</span>
                  <p class="text-xs mt-1">ติ๊กบริษัทจากฝั่งซ้ายเพื่อเพิ่ม</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Step 3: users -->
        <div *ngIf="wizardStep() === 3" class="space-y-4">
          <div class="rounded-xl border border-sky-200 bg-sky-50/70 dark:bg-sky-950/20 p-3 text-xs text-sky-900 dark:text-sky-100 flex items-center gap-2">
            <span class="material-icons text-[18px]">info</span>
            ผู้ใช้ 1 คนอยู่ได้แค่ 1 กลุ่มต่อลาน (นับกลุ่มที่ปิดอยู่ด้วย) — คนที่อยู่กลุ่มอื่นแล้วจะเลือกไม่ได้ ต้องเอาออกจากกลุ่มเดิมก่อน
          </div>
          <div class="grid grid-cols-1 xl:grid-cols-2 gap-4">
            <!-- search side -->
            <div class="rounded-2xl border border-slate-200 dark:border-slate-700 overflow-hidden flex flex-col">
              <div class="p-3 border-b border-slate-100 dark:border-slate-800 space-y-2">
                <p class="text-xs font-bold text-slate-500 uppercase">1 · ค้นหาผู้ใช้</p>
                <div class="relative">
                  <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[20px]">person_search</span>
                  <input type="text" [(ngModel)]="userSearch" (ngModelChange)="onUserSearchChange()"
                    placeholder="ชื่อ / login / ID"
                    class="w-full pl-10 pr-4 py-2.5 bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 text-sm focus:ring-2 focus:ring-amber-200 focus:outline-none" />
                </div>
                <div class="flex flex-wrap items-center justify-between gap-2 text-xs">
                  <label class="inline-flex items-center gap-2 cursor-pointer text-slate-500">
                    <input type="checkbox" class="accent-amber-500" [(ngModel)]="userHideAssigned" (ngModelChange)="onUserHideAssignedChange()" />
                    ซ่อนคนที่อยู่กลุ่มอื่นแล้ว
                  </label>
                  <span class="text-slate-400">พบ {{ userTotal() | number }} คน</span>
                  <button type="button" (click)="toggleAllUsersOnPage()" [disabled]="isLocked || !userOptions().length"
                    class="font-bold text-amber-600 disabled:opacity-40">
                    {{ allUsersOnPageSelected ? 'เอาออกทั้งหน้านี้' : 'เลือกทั้งหน้านี้' }}
                  </button>
                </div>
              </div>
              <div class="relative flex-1 min-h-[320px] max-h-[420px] overflow-y-auto custom-scrollbar divide-y divide-slate-50 dark:divide-slate-800">
                <label *ngFor="let u of userOptions(); trackBy: trackById"
                  class="flex items-center gap-3 px-4 py-2.5 transition-all"
                  [ngClass]="isUserBlocked(u) ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer hover:bg-amber-50/60 dark:hover:bg-slate-800/50'"
                  [class.bg-amber-50]="isUserSelected(u.id)">
                  <input type="checkbox" class="w-4 h-4 accent-amber-500" [checked]="isUserSelected(u.id)" (change)="toggleUser(u)"
                    [disabled]="isLocked || isUserBlocked(u)" />
                  <span class="min-w-0 flex-1">
                    <span class="block font-semibold text-slate-800 dark:text-slate-100 truncate">{{ u.displayName }}</span>
                    <span class="block text-[11px] text-slate-400 font-mono truncate">
                      {{ u.login || '—' }} · #{{ u.id }}<span *ngIf="u.roleName" class="font-sans"> · {{ u.roleName }}</span>
                    </span>
                  </span>
                  <span *ngIf="isUserBlocked(u)"
                    class="shrink-0 max-w-[140px] truncate inline-flex px-2 py-0.5 rounded-lg text-[11px] font-semibold bg-slate-100 text-slate-500 dark:bg-slate-800"
                    [title]="'อยู่กลุ่ม ' + u.groupName">
                    อยู่กลุ่ม {{ u.groupName || ('#' + u.groupId) }}
                  </span>
                </label>
                <p *ngIf="!userOptions().length && !isUserLoading()" class="p-8 text-center text-slate-400">ไม่พบผู้ใช้ตามคำค้น</p>
                <div *ngIf="isUserLoading()" class="absolute inset-0 bg-white/60 dark:bg-slate-900/60 flex items-center justify-center">
                  <span class="material-icons animate-spin text-amber-400 text-3xl">autorenew</span>
                </div>
              </div>
              <div *ngIf="userTotalPages() > 1" class="p-2 border-t border-slate-100 dark:border-slate-800 flex items-center justify-between text-xs">
                <button type="button" (click)="setUserPage(userPage() - 1)" [disabled]="userPage() === 1"
                  class="w-8 h-8 rounded-lg border border-slate-200 flex items-center justify-center disabled:opacity-30 hover:text-amber-500">
                  <span class="material-icons text-sm">chevron_left</span>
                </button>
                <span class="font-bold text-slate-500">หน้า {{ userPage() }} / {{ userTotalPages() }}</span>
                <button type="button" (click)="setUserPage(userPage() + 1)" [disabled]="userPage() >= userTotalPages()"
                  class="w-8 h-8 rounded-lg border border-slate-200 flex items-center justify-center disabled:opacity-30 hover:text-amber-500">
                  <span class="material-icons text-sm">chevron_right</span>
                </button>
              </div>
            </div>

            <!-- selected side -->
            <div class="rounded-2xl border border-amber-200 dark:border-amber-900/50 overflow-hidden flex flex-col">
              <div class="p-3 border-b border-amber-100 dark:border-amber-900/40 bg-amber-50/50 dark:bg-amber-950/20 space-y-2">
                <div class="flex items-center justify-between">
                  <p class="text-xs font-bold text-amber-700 uppercase">2 · สมาชิกที่เลือก {{ form.resUserIds.length | number }} คน</p>
                  <button type="button" (click)="clearUsers()" [disabled]="isLocked || !form.resUserIds.length"
                    class="text-xs font-bold text-rose-500 disabled:opacity-40">ล้างทั้งหมด</button>
                </div>
                <div *ngIf="form.resUserIds.length > 8" class="relative">
                  <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[18px]">filter_list</span>
                  <input type="text" [(ngModel)]="selectedUserFilter" placeholder="กรองในรายชื่อที่เลือก..."
                    class="w-full pl-9 pr-3 py-2 bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 text-xs focus:outline-none focus:ring-2 focus:ring-amber-200" />
                </div>
              </div>
              <div class="relative flex-1 min-h-[320px] max-h-[420px] overflow-y-auto custom-scrollbar divide-y divide-slate-50 dark:divide-slate-800">
                <div *ngFor="let u of selectedUsers; trackBy: trackById" class="flex items-center gap-3 px-4 py-2.5">
                  <span class="w-8 h-8 shrink-0 rounded-full bg-amber-100 text-amber-700 flex items-center justify-center text-xs font-black">
                    {{ u.displayName.charAt(0) }}
                  </span>
                  <span class="min-w-0 flex-1">
                    <span class="block font-semibold text-slate-800 dark:text-slate-100 truncate">{{ u.displayName }}</span>
                    <span class="block text-[11px] text-slate-400 font-mono truncate">{{ u.login || '—' }} · #{{ u.id }}</span>
                  </span>
                  <button type="button" (click)="removeUser(u.id)" [disabled]="isLocked" title="เอาออก"
                    class="w-7 h-7 rounded-lg flex items-center justify-center text-slate-400 hover:text-rose-500 hover:bg-rose-50">
                    <span class="material-icons text-[16px]">close</span>
                  </button>
                </div>
                <div *ngIf="!form.resUserIds.length" class="p-8 text-center text-slate-400">
                  <span class="material-icons text-3xl">touch_app</span>
                  <p class="text-xs mt-1">ติ๊กผู้ใช้จากฝั่งซ้ายเพื่อเพิ่มเข้ากลุ่ม</p>
                </div>
                <div *ngIf="isMembersLoading()" class="absolute inset-0 bg-white/60 dark:bg-slate-900/60 flex items-center justify-center">
                  <span class="material-icons animate-spin text-amber-400 text-3xl">autorenew</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Step 4: permissions -->
        <div *ngIf="wizardStep() === 4" class="space-y-3 max-w-2xl">
          <label class="flex items-start gap-3 p-4 rounded-xl border cursor-pointer transition-all"
            [ngClass]="form.canManageQuota ? 'border-sky-300 bg-sky-50/50 dark:bg-sky-950/20' : 'border-slate-200 dark:border-slate-700'">
            <input type="checkbox" class="mt-1 w-4 h-4 accent-amber-500" [(ngModel)]="form.canManageQuota" [disabled]="isLocked" />
            <span>
              <span class="font-bold block text-slate-800 dark:text-slate-100">จัดการโควต้า</span>
              <span class="text-xs text-slate-400">แจก / ลด / คืนโควต้าให้บริษัทผู้เช่า</span>
            </span>
          </label>
          <label class="flex items-start gap-3 p-4 rounded-xl border cursor-pointer transition-all"
            [ngClass]="form.canManageFreeCards ? 'border-emerald-300 bg-emerald-50/50 dark:bg-emerald-950/20' : 'border-slate-200 dark:border-slate-700'">
            <input type="checkbox" class="mt-1 w-4 h-4 accent-amber-500" [(ngModel)]="form.canManageFreeCards" [disabled]="isLocked" />
            <span>
              <span class="font-bold block text-slate-800 dark:text-slate-100">จัดการบัตรจอดฟรี</span>
              <span class="text-xs text-slate-400">ดู / ออกบัตรและ Advance จอดฟรี</span>
            </span>
          </label>
          <label class="flex items-start gap-3 p-4 rounded-xl border cursor-pointer transition-all"
            [ngClass]="form.canDeleteCardReturnQuota ? 'border-rose-300 bg-rose-50/50 dark:bg-rose-950/20' : 'border-slate-200 dark:border-slate-700'">
            <input type="checkbox" class="mt-1 w-4 h-4 accent-amber-500" [(ngModel)]="form.canDeleteCardReturnQuota" [disabled]="isLocked" />
            <span>
              <span class="font-bold block text-slate-800 dark:text-slate-100">ลบบัตรแล้วคืนโควต้า</span>
              <span class="text-xs text-slate-400">อนุญาตลบบัตรจอดฟรีและคืนโควต้ากลับ</span>
            </span>
          </label>
        </div>

        <!-- Step 5: subscriptions -->
        <div *ngIf="wizardStep() === 5" class="space-y-4 max-w-3xl">
          <div class="rounded-xl border border-sky-200 bg-sky-50/70 dark:bg-sky-950/20 p-3 text-xs text-sky-900 dark:text-sky-100 flex items-center gap-2">
            <span class="material-icons text-[18px]">info</span>
            แสดงเฉพาะ Subscription ที่ติ๊ก "จอดฟรี" แล้ว (เมนูจัดการ Subscription)
          </div>
          <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
            <div class="relative flex-1 max-w-md">
              <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[20px]">search</span>
              <input type="text" [(ngModel)]="subSearch" placeholder="ค้นหา Subscription..."
                class="w-full pl-10 pr-4 py-2.5 bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 text-sm focus:ring-2 focus:ring-amber-200 focus:outline-none" />
            </div>
            <div class="flex items-center gap-3 text-xs">
              <span class="text-slate-400">เลือกแล้ว {{ form.subscriptionIds.length }} รายการ</span>
              <button type="button" (click)="selectAllVisibleSubs()" [disabled]="isLocked || !filteredSubscriptions.length"
                class="font-bold text-amber-600 disabled:opacity-40">เลือกทั้งหมดที่แสดง</button>
            </div>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-2">
            <label *ngFor="let s of filteredSubscriptions; trackBy: trackById"
              class="flex items-center gap-3 px-4 py-3 rounded-xl border cursor-pointer transition-all"
              [ngClass]="isSubSelected(s.id) ? 'border-amber-300 bg-amber-50/60 dark:bg-amber-950/20' : 'border-slate-200 dark:border-slate-700 hover:border-amber-200'">
              <input type="checkbox" class="w-4 h-4 accent-amber-500" [checked]="isSubSelected(s.id)" (change)="toggleSub(s.id)" [disabled]="isLocked" />
              <span class="min-w-0">
                <span class="block font-semibold text-slate-800 dark:text-slate-100 truncate">{{ s.name }}</span>
                <span class="block text-[11px] text-slate-400">#{{ s.id }}<span *ngIf="s.vehicleTypeName"> · {{ s.vehicleTypeName }}</span></span>
              </span>
            </label>
          </div>
          <p *ngIf="!filteredSubscriptions.length" class="p-8 text-center text-slate-400 rounded-xl border border-dashed border-slate-200">
            ไม่พบ Subscription จอดฟรีในลานนี้ — ไปติ๊กที่เมนูจัดการ Subscription ก่อน
          </p>
        </div>

        <!-- Step 6: review -->
        <div *ngIf="wizardStep() === 6" class="space-y-4 max-w-4xl">
          <div class="rounded-xl border border-emerald-200 bg-emerald-50/70 dark:bg-emerald-950/20 p-3 text-xs text-emerald-900 dark:text-emerald-100 flex items-center gap-2">
            <span class="material-icons text-[18px]">fact_check</span>
            ตรวจสรุปก่อนบันทึก — กดหัวข้อเพื่อกลับไปแก้ขั้นนั้น
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
            <button type="button" (click)="goStep(1)" class="text-left rounded-xl border border-slate-100 dark:border-slate-800 p-4 hover:border-amber-300">
              <p class="text-xs text-slate-400 font-bold uppercase">หมวดหมู่ / ชื่อกลุ่ม</p>
              <p class="font-extrabold text-slate-800 dark:text-slate-100 mt-1">{{ form.name }}</p>
              <p class="text-xs mt-1">
                <span class="font-semibold">{{ formCategory.label }}</span>
                · <span [ngClass]="form.active ? 'text-emerald-600' : 'text-slate-400'">{{ form.active ? 'เปิดใช้' : 'ปิด' }}</span>
              </p>
            </button>
            <button type="button" (click)="goStep(4)" class="text-left rounded-xl border border-slate-100 dark:border-slate-800 p-4 hover:border-amber-300">
              <p class="text-xs text-slate-400 font-bold uppercase">สิทธิ์</p>
              <div class="mt-2 flex flex-wrap gap-1">
                <span *ngIf="form.canManageQuota" class="text-[11px] px-2 py-0.5 rounded-lg font-semibold bg-sky-50 text-sky-700">จัดการโควต้า</span>
                <span *ngIf="form.canManageFreeCards" class="text-[11px] px-2 py-0.5 rounded-lg font-semibold bg-emerald-50 text-emerald-700">บัตรจอดฟรี</span>
                <span *ngIf="form.canDeleteCardReturnQuota" class="text-[11px] px-2 py-0.5 rounded-lg font-semibold bg-rose-50 text-rose-700">ลบคืนโควต้า</span>
                <span *ngIf="!form.canManageQuota && !form.canManageFreeCards && !form.canDeleteCardReturnQuota" class="text-xs text-slate-400">ไม่มีสิทธิ์ใด ๆ</span>
              </div>
            </button>
            <button type="button" (click)="goStep(2)" class="text-left rounded-xl border border-slate-100 dark:border-slate-800 p-4 hover:border-amber-300 md:col-span-2">
              <p class="text-xs text-slate-400 font-bold uppercase">
                บริษัทผู้เช่า · {{ clientScopeMode === 'all' ? 'ทุกบริษัทในลาน' : (form.clientIds.length + ' บริษัท') }}
              </p>
              <div *ngIf="clientScopeMode === 'specific'" class="mt-2 flex flex-wrap gap-1.5">
                <span *ngFor="let c of reviewClients.slice(0, previewLimit)"
                  class="inline-flex px-2 py-0.5 rounded-lg text-[11px] font-semibold bg-violet-50 text-violet-700">{{ c.name }}</span>
                <span *ngIf="reviewClients.length > previewLimit" class="text-[11px] font-bold text-slate-500">
                  และอีก {{ reviewClients.length - previewLimit }} บริษัท
                </span>
              </div>
            </button>
            <button type="button" (click)="goStep(3)" class="text-left rounded-xl border border-slate-100 dark:border-slate-800 p-4 hover:border-amber-300 md:col-span-2">
              <p class="text-xs text-slate-400 font-bold uppercase">สมาชิก · {{ form.resUserIds.length }} คน</p>
              <div class="mt-2 flex flex-wrap gap-1.5">
                <span *ngFor="let u of reviewUsers.slice(0, previewLimit)"
                  class="inline-flex px-2 py-0.5 rounded-lg text-[11px] font-semibold bg-amber-50 text-amber-700">{{ u.displayName }}</span>
                <span *ngIf="reviewUsers.length > previewLimit" class="text-[11px] font-bold text-slate-500">
                  และอีก {{ reviewUsers.length - previewLimit }} คน
                </span>
              </div>
            </button>
            <button type="button" (click)="goStep(5)" class="text-left rounded-xl border border-slate-100 dark:border-slate-800 p-4 hover:border-amber-300 md:col-span-2">
              <p class="text-xs text-slate-400 font-bold uppercase">Subscription จอดฟรี · {{ form.subscriptionIds.length }} รายการ</p>
              <div class="mt-2 flex flex-wrap gap-1.5">
                <span *ngFor="let s of selectedSubscriptions"
                  class="inline-flex px-2 py-0.5 rounded-lg text-[11px] font-semibold bg-emerald-50 text-emerald-700">{{ s.name }}</span>
              </div>
            </button>
          </div>
        </div>

        <!-- Nav -->
        <div class="flex flex-wrap items-center justify-between gap-3 mt-8 pt-5 border-t border-slate-100 dark:border-slate-800">
          <button type="button" (click)="wizardStep() === 1 ? backToList() : prevStep()" [disabled]="isSaving()"
            class="px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 font-bold disabled:opacity-40 inline-flex items-center gap-1 hover:bg-slate-50">
            <span class="material-icons text-[18px]">chevron_left</span>
            {{ wizardStep() === 1 ? 'ยกเลิก' : 'ย้อนกลับ' }}
          </button>
          <div class="flex gap-2">
            <button *ngIf="wizardStep() < wizardSteps.length" type="button" (click)="nextStep()" [disabled]="isSaving()"
              class="px-5 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold inline-flex items-center gap-1">
              ถัดไป: {{ wizardSteps[wizardStep()].title }}
              <span class="material-icons text-[18px]">chevron_right</span>
            </button>
            <button *ngIf="wizardStep() === wizardSteps.length && canUpdate" type="button" (click)="onSave()" [disabled]="isSaving()"
              class="px-5 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold disabled:opacity-50 inline-flex items-center gap-2">
              <span class="material-icons text-[18px]">save</span>
              {{ isSaving() ? 'กำลังบันทึก...' : (isCreate ? 'สร้างกลุ่ม' : 'บันทึกการแก้ไข') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<app-modal-admin-activity-history *ngIf="showActivityHistory"
  [entityType]="activityEntityType"
  [entityId]="historyEntityId"
  title="ประวัติกลุ่มสิทธิ์จอดฟรี"
  [subtitle]="historySubtitle"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>

<app-pss-confirm-modal *ngIf="showConfirm"
  [title]="confirmTitle"
  [message]="confirmMessage"
  [highlight]="confirmHighlight"
  [messageSuffix]="confirmMessageSuffix"
  confirmLabel="ใช่"
  cancelLabel="ไม่"
  [variant]="confirmVariant"
  [icon]="confirmIcon"
  [loading]="confirmLoading"
  [showIrreversibleNote]="false"
  (confirm)="onConfirmYes()"
  (cancel)="onConfirmNo()">
</app-pss-confirm-modal>
